import gql from 'graphql-tag';

export default gql`
query getImagesByGroupId($group_id: Int!, $limit: Int = 12, $offset: Int = 0) {
  images(
    where: {group_id: {_eq: $group_id}}
    order_by: {created_at: desc}
    limit: $limit
    offset: $offset
  ) {
    image_id
    name
    url
    author
    metadata
    created_at
  }
}
`;
